import classNames from "classnames";
import { useFieldWithInitialValue } from "Components/Hooks";
import React from "react";
import { renderErrorMessage, doesMetaHaveError } from "./Tools";

export function EmailInput(props: { fieldName: string; placeholder?: string }) {
  return <Textbox {...props} type="email" />;
}

export function Textbox(props: {
  fieldName: string;
  placeholder?: string;
  className?: string;
  type?: string;
  textboxIcon?: React.ReactNode;
  isDisabled?: boolean;
  value?: string;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
}) {
  const [field, meta] = useFieldWithInitialValue(props.fieldName, props.value);
  return (
    <div className="field">
      <div
        className={classNames("control is-expanded", {
          "has-icons-left": !!props.textboxIcon,
        })}
      >
        <input
          {...props.inputProps}
          {...field}
          className={classNames("input", props.className, {
            "input-validation-error": doesMetaHaveError(meta),
          })}
          id={props.fieldName}
          disabled={props.isDisabled}
          placeholder={props.placeholder}
          type={props.type || "text"}
          value={field.value || ""}
          onBlur={e => {
            field.onBlur(e);
            props.inputProps &&
              props.inputProps.onBlur &&
              props.inputProps.onBlur(e);
          }}
          onChange={e => {
            field.onChange(e);
            props.inputProps &&
              props.inputProps.onChange &&
              props.inputProps.onChange(e);
          }}
        />
        {renderErrorMessage(meta)}
        {props.textboxIcon}
      </div>
    </div>
  );
}
